import React, { useState } from "react";
import { Form, Col } from "react-bootstrap";

const UserNameSection = (props) => {
  const [employeeName, setEmployeeName] = useState(props.employeeName);

  const handleNameChange = (name) => {
    if (props.mode === "add") {
      props.setUser((prevUserToAdd) => ({
        ...prevUserToAdd,
        fullName: name,
      }));
    } else if (props.mode === "update") {
      props.setUser((prevUserToAdd) => ({
        ...prevUserToAdd,
        UpdatedUserFullName: name,
      }));
    }
    setEmployeeName(name);
  };
  return (
    <Form.Group controlId="userDomainName" as={Col}>
      <Col sm="3">Employee Name</Col>
      <Col>
        <Form.Control
          type="text"
          custom
          onChange={(e) => handleNameChange(e.target.value)}
          value={employeeName}
        ></Form.Control>
      </Col>
    </Form.Group>
  );
};

export default UserNameSection;
